import { useEffect, useState } from "react";
import { Timer as TimerIcon, AlertCircle } from "lucide-react";

const fmt = (s) => `${Math.floor(s / 60)}:${String(s % 60).padStart(2, "0")}`;

// Per-question countdown for live drills. `remaining` is the server's seconds-left snapshot (refreshed on every
// state broadcast); we count down locally in between so the badge ticks every second.
export const QuestionCountdown = ({ remaining, limit, className = "", testId = "live-countdown" }) => {
  const [deadline, setDeadline] = useState(null);
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    if (remaining == null) { setDeadline(null); return; }
    setDeadline(Date.now() + remaining * 1000);
  }, [remaining]);

  useEffect(() => {
    if (deadline == null) return undefined;
    const id = setInterval(() => setNow(Date.now()), 500);
    return () => clearInterval(id);
  }, [deadline]);

  if (deadline == null) return null;
  const left = Math.max(0, Math.ceil((deadline - now) / 1000));
  const critical = left <= 10;
  const low = left <= 60;
  const tone = left === 0 || critical
    ? "bg-destructive/15 text-destructive border-destructive/40 animate-pulse"
    : low
      ? "bg-amber-500/15 text-amber-700 dark:text-amber-400 border-amber-500/40"
      : "bg-primary/10 text-primary border-primary/30";
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full border px-3 py-1 font-mono text-sm font-semibold tabular-nums ${tone} ${className}`}
      title={limit ? `${Math.round(limit / 60)} minute${limit >= 120 ? "s" : ""} per question` : undefined}
      data-testid={testId}
      data-seconds-left={left}
    >
      {critical ? <AlertCircle className="w-4 h-4" /> : <TimerIcon className="w-4 h-4" />}
      {left === 0 ? "Time's up" : fmt(left)}
    </span>
  );
};
